import { onMounted, ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61377b19"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content-wrap"
};
const _hoisted_2 = {
  class: "new-order-filter-header"
};
const _hoisted_3 = {
  class: "flex-list"
};
const _hoisted_4 = {
  class: "flex-left"
};
const _hoisted_5 = {
  class: "form-row"
};
const _hoisted_6 = {
  class: "appListPopover-content"
};
const _hoisted_7 = {
  class: "appListPopover-content-title"
};
const _hoisted_8 = {
  class: "inf-label"
};
const _hoisted_9 = {
  class: "inf-value"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_11 = {
  class: "form-row"
};
const _hoisted_12 = {
  class: "form-row"
};
const _hoisted_13 = {
  class: "form-row"
};
const _hoisted_14 = {
  class: "flex-right"
};
const _hoisted_15 = {
  class: "form-row"
};
import dayjs from 'dayjs';
import useFilterHeader from '../../newOrderList/components/useFilterHeader';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { detailFields, searchFields, getAppListInformation, copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterHeader',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const {
      productSelectRef,
      isOpen,
      refundStatusList,
      chnlList,
      originFilterForm,
      filterForm,
      getNode,
      changeApp
    } = useFilterHeader();
    onMounted(() => {
      filterForm.time_range = [];
      filterForm.refundTime = [];
    });
    const datePickerRef = ref(null);
    const datePickerRef2 = ref(null);
    const onFinish = () => {
      var _filterForm$time_rang, _filterForm$time_rang2;
      // 判断是否选择了自定义时间
      if (((_filterForm$time_rang = filterForm.time_range[0]) === null || _filterForm$time_rang === void 0 ? void 0 : _filterForm$time_rang.length) === 8) {
        filterForm.time_range[0] = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD') + ' 00:00:00';
      }
      if (((_filterForm$time_rang2 = filterForm.time_range[1]) === null || _filterForm$time_rang2 === void 0 ? void 0 : _filterForm$time_rang2.length) === 8) {
        filterForm.time_range[1] = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD') + ' 23:59:59';
      }
      let params = {};
      params = {
        ...filterForm
      };
      // 退款发起时间
      if (filterForm.refundTime.length > 0 && filterForm.refundTime[0] && filterForm.refundTime[1]) {
        params.refundStartDate = dayjs(filterForm.refundTime[0]).format('YYYY-MM-DD HH:mm:ss');
        params.refundEndDate = dayjs(filterForm.refundTime[1]).format('YYYY-MM-DD HH:mm:ss');
      }
      // 订单创建时间
      if (filterForm.time_range.length > 0 && filterForm.time_range[0] && filterForm.time_range[1]) {
        params.orderStartDate = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD HH:mm:ss');
        params.orderEndDate = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD HH:mm:ss');
      }
      delete params.orderUnion;
      delete params.userIdentityUnion;
      delete params.time_range;
      delete params.quick_time;
      delete params.query_time;
      delete params.refundTime;
      delete params.pkg;
      delete params.prodId;
      delete params.chnlFlag;
      emit('filterSubmit', params);
    }; // 订单列表搜索
    const resetForm = () => {
      Object.keys(filterForm).forEach(key => {
        filterForm[key] = originFilterForm[key];
      });
      filterForm.refundTime = [];
      filterForm.time_range = [];
      datePickerRef.value.timeStart = dayjs('00:00:00', 'HH:mm:ss');
      datePickerRef.value.timeEnd = dayjs('23:59:59', 'HH:mm:ss');
      datePickerRef2.value.timeStart = dayjs('00:00:00', 'HH:mm:ss');
      datePickerRef2.value.timeEnd = dayjs('23:59:59', 'HH:mm:ss');
      onFinish();
    }; // 重置搜索
    const changeStartHms = value => {
      filterForm.time_range[0] = dayjs(filterForm.time_range[0]).format('YYYYMMDD') + ' ' + value;
    }; // 修改开始时间
    const changeEndHms = value => {
      filterForm.time_range[1] = dayjs(filterForm.time_range[1]).format('YYYYMMDD') + ' ' + value;
    }; // 修改结束时间
    const changeStartHms2 = value => {
      filterForm.refundTime[0] = dayjs(filterForm.refundTime[0]).format('YYYYMMDD') + ' ' + value;
    }; // 修改开始时间
    const changeEndHms2 = value => {
      filterForm.refundTime[1] = dayjs(filterForm.refundTime[1]).format('YYYYMMDD') + ' ' + value;
    }; // 修改结束时间
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_DbtDatePicker = _resolveComponent("DbtDatePicker");
      const _component_a_input = _resolveComponent("a-input");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_form, {
        layout: "inline",
        model: _unref(filterForm),
        onFinish: onFinish
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_form_item, {
          label: "产品名称：",
          name: "dbtId",
          rules: [{
            required: true,
            message: '请选择产品'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
            ref_key: "productSelectRef",
            ref: productSelectRef,
            modelValue: _unref(filterForm).dbtId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filterForm).dbtId = $event),
            multiple: false,
            "show-extra": true,
            "search-fields": _unref(searchFields),
            "max-tag-count": 1,
            "show-detail": true,
            layout: "vertical",
            descriptionField: "filePath",
            width: 200,
            "popup-class-name": "vertical-product-select",
            placeholder: "请选择",
            detailFields: _unref(detailFields),
            onChange: _unref(changeApp),
            "show-bottom-border": ""
          }, {
            detail: _withCtx(({
              detail
            }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_SvgIcon, {
              iconClass: "informationIcon",
              class: "informationIcon"
            }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
              return _openBlock(), _createElementBlock("div", {
                key: child.label,
                class: "inf-line"
              }, [_createElementVNode("div", _hoisted_8, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_9, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
                placement: "top"
              }, {
                title: _withCtx(() => [_hoisted_10]),
                default: _withCtx(() => [_createVNode(_component_SvgIcon, {
                  iconClass: "copy",
                  class: "dbt-copyIcon",
                  onClick: $event => _unref(copy)(child.value)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)]);
            }), 128))])]),
            _: 1
          }, 8, ["modelValue", "search-fields", "detailFields", "onChange"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "订单创建"
        }, {
          default: _withCtx(() => [_createVNode(_component_DbtDatePicker, {
            ref_key: "datePickerRef",
            ref: datePickerRef,
            "show-use-server-time": false,
            "show-header": false,
            "show-dynamic": false,
            "show-quick": false,
            "is-required": false,
            isdeletion: true,
            "show-time-range": "",
            startTime: _unref(filterForm).time_range[0],
            "onUpdate:startTime": _cache[1] || (_cache[1] = $event => _unref(filterForm).time_range[0] = $event),
            endTime: _unref(filterForm).time_range[1],
            "onUpdate:endTime": _cache[2] || (_cache[2] = $event => _unref(filterForm).time_range[1] = $event),
            position: "bottomLeft",
            onChangeStartHms: changeStartHms,
            onChangeEndHms: changeEndHms
          }, null, 8, ["startTime", "endTime"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "退款发起："
        }, {
          default: _withCtx(() => [_createVNode(_component_DbtDatePicker, {
            ref_key: "datePickerRef2",
            ref: datePickerRef2,
            "show-use-server-time": false,
            "show-header": false,
            "show-dynamic": false,
            "show-quick": false,
            "is-required": false,
            isdeletion: true,
            "show-time-range": "",
            startTime: _unref(filterForm).refundTime[0],
            "onUpdate:startTime": _cache[3] || (_cache[3] = $event => _unref(filterForm).refundTime[0] = $event),
            endTime: _unref(filterForm).refundTime[1],
            "onUpdate:endTime": _cache[4] || (_cache[4] = $event => _unref(filterForm).refundTime[1] = $event),
            position: "bottomLeft",
            onChangeStartHms: changeStartHms2,
            onChangeEndHms: changeEndHms2
          }, null, 8, ["startTime", "endTime"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_a_form_item, {
          label: "DBT订单：",
          name: "orderNo"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).orderNo,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => _unref(filterForm).orderNo = $event),
            placeholder: "请输入DBT订单号",
            style: {
              "width": "210px"
            },
            onChange: _cache[6] || (_cache[6] = e => _unref(filterForm).orderNo = e.target.value.trim())
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "三方订单：",
          name: "platOrderNo"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).platOrderNo,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => _unref(filterForm).platOrderNo = $event),
            placeholder: "请输入三方订单号",
            style: {
              "width": "210px"
            },
            onChange: _cache[8] || (_cache[8] = e => _unref(filterForm).platOrderNo = e.target.value.trim())
          }, null, 8, ["value"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[9] || (_cache[9] = $event => isOpen.value = true)
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "arrow_blue"
            }), _createTextVNode(" 展开 ")]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, !_unref(isOpen)]])]), _withDirectives(_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_form_item, {
          label: "设备ID：",
          name: "deviceId"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).deviceId,
            "onUpdate:value": _cache[10] || (_cache[10] = $event => _unref(filterForm).deviceId = $event),
            placeholder: "请输入设备ID",
            style: {
              "width": "210px"
            },
            onChange: _cache[11] || (_cache[11] = e => _unref(filterForm).deviceId = e.target.value.trim())
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "用户ID：",
          name: "userId"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).userId,
            "onUpdate:value": _cache[12] || (_cache[12] = $event => _unref(filterForm).userId = $event),
            placeholder: "请输入用户ID",
            style: {
              "width": "210px"
            },
            onChange: _cache[13] || (_cache[13] = e => _unref(filterForm).userId = e.target.value.trim())
          }, null, 8, ["value"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[14] || (_cache[14] = $event => isOpen.value = true)
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "arrow_blue"
            }), _createTextVNode(" 展开 ")]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, !_unref(isOpen)]])], 512), [[_vShow, _unref(isOpen)]]), _withDirectives(_createElementVNode("div", _hoisted_13, [_createVNode(_component_a_form_item, {
          label: "支付渠道：",
          name: "payChnl"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).payChnl,
            "onUpdate:value": _cache[15] || (_cache[15] = $event => _unref(filterForm).payChnl = $event),
            style: {
              "width": "210px"
            },
            placeholder: "全部",
            options: _unref(chnlList)
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "退款状态：",
          name: "refundStatus"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            "allow-clear": "",
            value: _unref(filterForm).refundStatus,
            "onUpdate:value": _cache[16] || (_cache[16] = $event => _unref(filterForm).refundStatus = $event),
            placeholder: "请选择",
            getPopupContainer: _unref(getNode),
            options: _unref(refundStatusList)
          }, null, 8, ["value", "getPopupContainer", "options"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[17] || (_cache[17] = $event => isOpen.value = false)
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "arrow_blue",
              class: "close-icon"
            }), _createTextVNode(" 收起 ")]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, _unref(isOpen)]])], 512), [[_vShow, _unref(isOpen)]])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            onClick: resetForm
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_a_button, {
            style: {
              "margin-left": "10px"
            },
            type: "primary",
            "html-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })])])])]),
        _: 1
      }, 8, ["model"])])]);
    };
  }
});